import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface AccountDetailsProps {
  user?: {
    name?: string | null;
    email?: string | null;
  } | null;
}

const AccountDetails = ({ user }: AccountDetailsProps) => {
  const [firstName = '', lastName = ''] = user?.name ? user.name.split(' ') : ['', ''];

  return (
    <div className="user-profile__details">
      <Text>First Name: </Text><Text>{firstName}</Text><br />
      <Text>Last Name: </Text><Text>{lastName}</Text><br />
      <Text>Email Address: </Text><Text>{user?.email || ''}</Text><br />
      <Text>Password: ****** </Text>
    </div>
  );
};

export default AccountDetails;
